module.exports = __webpack_public_path__ + "img/pen.77eee609.svg";